import { isProd } from '@/utils'

// Use prod endpoint for production and dev except for staging
const useProdEndpoint = (isProd && process.env.BUILD_ENV !== 'staging') // || process.env.NODE_ENV === 'development'

// export const apiEndpointBaseUrl =
//   useProdEndpoint ? 'https://api.yourzite.com' : 'http://dev.api.yourzite.com'

export const apiEndpointBaseUrl =
  useProdEndpoint ? 'https://api.yourzite.com' : 'http://dev.api.yourzite.com'

export const loginBaseUrl =
  useProdEndpoint ? 'https://login.yourzite.com' : 'http://dev.login.yourzite.com'

export const loginUrl = (token) => `${loginBaseUrl}/admin?memberToken=${token}&viaSignUp=true`



// WEBPACK FOOTER //
// ./src/site-config/index.js